export default __webpack_public_path__ + "static/media/two.acc819d1.jpeg";